import _styled, { default as _styled2 } from "styled-components";
var _class, _Disclaimer;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
// if we must use a placeholder image,
// do not bundle in the full res `wwwroot/images/bing-aerial-labels-wide.png`
// image as it's a 1.4mb png
// import bingAerialBackground from "../../wwwroot/images/bing-aerial-labels-wide-low-quality.jpg";
import styled, { withTheme } from "styled-components";
import Box from "../Styled/Box";
import Button from "../Styled/Button";
import Spacing from "../Styled/Spacing";
import Text from "../Styled/Text";
import parseCustomMarkdownToReact from "./Custom/parseCustomMarkdownToReact";
import { withViewState } from "./Context";
import FadeIn from "./Transitions/FadeIn/FadeIn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TopElementBox = styled(Box).withConfig({
  displayName: "Disclaimer__TopElementBox",
  componentId: "sc-1elr01x-0"
})(["z-index:99999;top:0;right:0;"]);

// background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
//   url(${bingAerialBackground});
const BackgroundImage = styled(Box).withConfig({
  displayName: "Disclaimer__BackgroundImage",
  componentId: "sc-1elr01x-1"
})(["background:rgba(0,0,0,0.75);z-index:0;"]);
const DisclaimerButton = styled(Button).attrs({
  textProps: {
    semiBold: true
  },
  rounded: true
}).withConfig({
  displayName: "Disclaimer__DisclaimerButton",
  componentId: "sc-1elr01x-2"
})(["width:", ";"], props => props.fullWidth ? "100%" : "280px");
let Disclaimer = observer(_class = (_Disclaimer = class Disclaimer extends Component {
  confirm(confirmCallbackFn) {
    if (confirmCallbackFn) {
      confirmCallbackFn();
    }
    this.props.viewState.hideDisclaimer();
  }
  deny(denyCallbackFn) {
    if (denyCallbackFn) {
      denyCallbackFn();
    }
    // Otherwise, do nothing for now?
  }
  render() {
    const disclaimer = this.props.viewState.disclaimerSettings;
    const disclaimerTitle = (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.title) || "Disclaimer";
    const disclaimerConfirm = (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.confirmText) || "Ok";
    const disclaimerDeny = (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.denyText) || "Cancel";
    const disclaimerMessage = (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.message) || "Disclaimer text goes here";
    const useSmallScreenInterface = this.props.viewState.useSmallScreenInterface;
    const renderDenyButton = !!(disclaimer !== null && disclaimer !== void 0 && disclaimer.denyAction);
    return disclaimer ? /*#__PURE__*/_jsx(FadeIn, {
      isVisible: this.props.viewState.disclaimerVisible,
      children: /*#__PURE__*/_jsxs(TopElementBox, {
        position: "absolute",
        fullWidth: true,
        fullHeight: true,
        centered: true,
        children: [/*#__PURE__*/_jsx(BackgroundImage
        // // Make the image slightly larger to deal with
        // // image shrinking a tad bit when blurred
        // styledWidth={"110%"}
        // styledHeight={"110%"}
        , {
          fullWidth: true,
          fullHeight: true,
          position: "absolute"
        }), /*#__PURE__*/_jsxs(_StyledBox, {
          displayInlineBlock: true,
          left: true,
          styledWidth: useSmallScreenInterface ? "100%" : "613px",
          paddedRatio: 4,
          scroll: true,
          children: [/*#__PURE__*/_jsx(Text, {
            styledFontSize: "18px",
            styledLineHeight: "24px",
            bold: true,
            textLight: true,
            children: disclaimerTitle
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 4
          }), /*#__PURE__*/_jsx(_StyledText, {
            styledLineHeight: "18px",
            textLight: true,
            $_css: this.props.theme.colorPrimary,
            children: parseCustomMarkdownToReact(disclaimerMessage)
          }), /*#__PURE__*/_jsx(Spacing, {
            bottom: 5
          }), /*#__PURE__*/_jsxs(Box, {
            fullWidth: true,
            centered: true,
            displayInlineBlock: useSmallScreenInterface,
            children: [renderDenyButton && /*#__PURE__*/_jsx(DisclaimerButton, {
              denyButton: true,
              onClick: () => this.deny(disclaimer.denyAction),
              fullWidth: useSmallScreenInterface,
              children: disclaimerDeny
            }), useSmallScreenInterface ? /*#__PURE__*/_jsx(Spacing, {
              bottom: 3
            }) : /*#__PURE__*/_jsx(Spacing, {
              right: 3
            }), /*#__PURE__*/_jsx(DisclaimerButton, {
              onClick: () => this.confirm(disclaimer.confirmAction),
              fullWidth: useSmallScreenInterface || !renderDenyButton,
              primary: true,
              children: disclaimerConfirm
            })]
          })]
        })]
      })
    }) : null;
  }
}, _defineProperty(_Disclaimer, "displayName", "Disclaimer"), _defineProperty(_Disclaimer, "propTypes", {
  viewState: PropTypes.object,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired
}), _Disclaimer)) || _class;
export default withTranslation()(withViewState(withTheme(Disclaimer)));
var _StyledBox = styled(Box).withConfig({
  displayName: "Disclaimer___StyledBox",
  componentId: "sc-1elr01x-3"
})(["max-height:100%;overflow:auto;"]);
var _StyledText = styled(Text).withConfig({
  displayName: "Disclaimer___StyledText",
  componentId: "sc-1elr01x-4"
})(["a{font-weight:600;color:", ";text-decoration:none;}"], p => p.$_css);